<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader @custom-event="getToken"></cnHeader>
		
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span><a href="/cn/user/index">我的账户</a><span class="space">/</span>收藏夹
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
		</div>
		
		<div class="pub_div new_user_center_box">
			
			<!--左侧菜单-开始-->
			<cnUserLeftPannel :fileName="'collections'" :Token="this.token"></cnUserLeftPannel>
			<!--左侧菜单-结束-->
			
			<!--右侧内容-开始-->
			<div class="right_content_box">
				<h1>收藏夹</h1>
				
				<!--筛选-开始-->
				<div class="head_box">
					<div class="type_box">
						<ul>
							<li :class="item.Id == columnId ? 'selected':''" v-for="(item, index) in columnIdList" :key="index" @click="changeColumnId(item.Id)">{{item.Title}}</li>
						</ul>
					</div>
					<div class="total"><span v-if="recordTotal>0">共 {{recordTotal}} 条数据</span></div>
				</div>
				<!--筛选-结束-->
				
				<!--无数据-->
				<cnNoData :isShow="noDataIsShow"></cnNoData>
				
				<!--列表-开始-->
				<div class="items_box">
					
					<div class="item" v-for="(item, index) in collectionList" :key="index">
						<div class="tag" @click="collectionHandle(item.DataId,index)"></div>
						<a :href="'/cn/'+item.DataPath+'/detail?Id='+item.DataId" target="_blank">
							<div class="picture">
								<img :src="item.Picture" />
							</div>
							<p>{{item.Title}}</p>
						</a>
					</div>
					
				</div>
				<!--列表-结束-->
				
				<!--分页-开始-->
				<div class="page_ctrl" v-if="this.collectionList.length>0 && pageTotal>1">
					<el-pagination layout="prev, pager, next" :total="recordTotal" :current-page="pageIndex"
						:pager-count="5" :page-size="pageSize" :background="true" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
				<!--分页-结束-->
				
			</div>
			<!--右侧内容-结束-->
			
		</div>
		
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import {
		checkToken,
		getCollect,
		collection,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	import cnNoData from '@/components/cn_noData.vue'
	import cnUserLeftPannel from '@/components/cn_user_left_pannel.vue'
	export default {
		name: 'CN_UserCollections',
		mixins: [mixin],
		components: {
			cnHeader,
			cnFooter,
			cnNoData,
			cnUserLeftPannel,
		},
		data() {
			return {
				fullscreenLoading: false, //loading状态
				noDataIsShow: false, //无数据缺省
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				columnId: 0,	//默认频道，多日游套餐
				columnIdList: [
					{
						Id: 0,
						Title: "旅游套餐"
					},
					{
						Id: 1,
						Title: "景点玩乐"
					},
					{
						Id: 2,
						Title: "酒店"
					},
					{
						Id: 4,
						Title: "景点门票"
					}
				],
			
				pageIndex: 1, 		//页码，默认为1
				pageSize: 12, 		//每页显示条数
				pageTotal: 0, 		//总页数
				recordTotal: 0, 	//总条数
			
				collectionList: [],		//数据列表
				clickLock: false,
			}
		},
		created() {
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
					
					this.getData()
				}
				else				
				{
					this.$router.push({
						path: '/cn/user/login'
					})
				}
			},
			//获取数据
			async getData() {
				this.collectionList = []
				this.fullscreenLoading = true
				const { data: res } = await getCollect(this.language, this.token, this.terminal, this.columnId, this.pageIndex)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.collectionList = res.data.DataList
					this.pageTotal = res.data.PageTotal
					this.recordTotal = res.data.RecordTotal
					if (res.data.DataList.length > 0) {
						this.noDataIsShow = false
						this.$nextTick(() => {
							window.scrollTo(0, 0);
						});
					} else {
						this.noDataIsShow = true
					}
				} else {
					this.$message.error(res.errmsg);
				}
			},
			//切换页码
			handleCurrentChange(val) {
				this.pageIndex = val
				this.getData()
			},
			// 切换频道
			changeColumnId(Id)
			{
				if(this.columnId != Id)
				{
					this.columnId = Id
					this.pageIndex = 1
					this.getData()
				}
			},
			//移除收藏
			async collectionHandle(Id, index)
			{
				if(this.clickLock)
				{
					return
				}
				this.clickLock = true	//锁住按钮
				let params={
					Token: this.token,
					Terminal: this.terminal,
					ColumnId: this.columnId,
					Id: Id,
					Action: 0
				}
				const { data: res } = await collection(params)
				if (res.errcode === 0) {
					//移除对象
					this.collectionList.splice(index, 1)					
					
					if(this.collectionList.length ==0)
					{
						if(this.pageIndex > 1)
						{
							this.pageIndex--
							this.getData()
						}
						else {
							this.noDataIsShow = true
						}
					}
					
				} else {
					this.$message.error(res.errmsg);
				}
				this.clickLock = false	//解锁按钮
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		.head_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			
			.total {
				font-size: 13px;
			}
			
			.type_box {
				ul {
					display: flex;
					
					li {
						height: 32px;
						line-height: 32px;
						box-sizing: border-box;
						padding: 0 10px;
						border: #c4c4c4 solid 1px;
						border-radius: 5px;
						font-size: 13px;
						color: #333;
						cursor: pointer;
						margin-right: 12px;
						-webkit-transition: all .3s ease;
					}
					li:hover {
						background-color: #3D7856;
						color: #fff;	
					}
					li.selected {
						background-color: #3D7856;
						border: #3D7856 solid 1px;
						color: #fff;
					}
				}
			}
		}
		
		.items_box {
			display: flex;
			flex-wrap: wrap;
			margin-top: 30px;
			
			.item {
				width: 224px;
				box-sizing: border-box;
				border-radius: 8px;
				margin:0 24px 30px 0;
				cursor: pointer;
				-webkit-transition: all .3s ease;
				position: relative;
				
				
				.tag {
					position: absolute;
					top: 10px;
					right: 10px;
					z-index: 100;
					width: 32px;
					height: 32px;
					border-radius: 50%;
					cursor: pointer;
					background-color: #fff;
					background-image: url(@/assets/images/icons/remove2.png);
					background-position: center;
					background-repeat: no-repeat;
					background-size: 16px 16px;
					-webkit-transition: all .3s ease;
				}
				.tag:hover {
					background-color: #eee;
				}
				
				a {
					position: relative;
					display: block;
					color: #000;	
				}
				a:hover {
					color: #008768;
					text-decoration: underline;
				}
				.picture {
					position: relative;
					
					img {
						width: 100%;
						height: 146px;
						border-radius: 8px;
						display: block;
					}
				}
				p {
					margin-top: 8px;
					font-size: 13px;
					line-height: 150%;
				}
			}
			.item:nth-child(4n)
			{
				margin-right: 0px;
			}
		}
		
		/deep/ .el-pagination {
			font-size: 16px;
		}
		
		/deep/ .el-pager li {
			width: 36px;
			height: 36px;
			font-size: 16px;
			line-height: 36px;
			margin: 0 5px;
			border-radius: 5px;
		}
		
		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #3D7856;
			font-size: 16px;
		}
		
		/deep/ .el-pagination button {
			width: 36px;
			height: 36px;	
			border-radius: 5px;
		}
		
		/deep/ .el-pagination .btn-next .el-icon {
			font-size: 16px;
		}
		/deep/ .el-pagination .btn-prev .el-icon {			
			font-size: 16px;
		}
	}
</style>